import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { SecondaryTextButton } from '@bibliocommons/base-buttons';
import { Pin } from '@bibliocommons/base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { Pill } from '@bibliocommons/pill';

import ToggleSwitch from 'app/components/shared/ToggleSwitch';
import { getLabel } from 'app/helpers/facets/filterUtils';
import { activeFiltersShape } from 'app/shapes/search';

import './AppliedFilters.scss';

const AppliedFilters = ({
  appliedFilters,
  hasPinnedToggle,
  isPinned,
  isSingleBranch,
  toggleIsPinned,
  unapplyAllFilters,
  unapplyFilter
}) => {
  const intl = useIntl();

  return (
    <div className="cp-applied-filters">
      <div className="filters">
        <ScreenReaderMessage>
          <FormattedMessage id="search.applied_filters_sr" tagName="h2" />
        </ScreenReaderMessage>
        <ul className="filter-list">
          {appliedFilters.entrySeq().map(([fieldId, filters]) => {
            return filters.map(filter => {
              const label = getLabel(
                intl,
                fieldId === 'PRIMARY_LANGUAGE' ? 'LANGUAGE' : fieldId,
                filter.get('label') || filter.get('value'),
                isSingleBranch
              );

              return (
                <li className="filter-item" key={`${fieldId}-${filter.get('value')}`}>
                  <Pill handleDismiss={() => unapplyFilter(fieldId, filter)} icon={isPinned ? <Pin /> : null}>
                    {label}
                  </Pill>
                </li>
              );
            });
          })}
        </ul>
        {!appliedFilters.isEmpty() && (
          <SecondaryTextButton
            className="unapply-all"
            dataKey="unapply-all-filters"
            handleClick={unapplyAllFilters}
            leftAligned
          >
            <FormattedMessage id="clear_filters" />
          </SecondaryTextButton>
        )}
      </div>

      {hasPinnedToggle && (
        <div className="pinned-toggle">
          <ToggleSwitch
            active={isPinned}
            activeText="Pin filters"
            className="toggle-switch"
            handleClick={toggleIsPinned}
            id="PinFiltersToggle"
            inactiveText="Pin filters"
          />
          <ScreenReaderMessage>
            <FormattedMessage id={isPinned ? 'active_filters_locked' : 'active_filters_unlocked'} />
          </ScreenReaderMessage>
        </div>
      )}
    </div>
  );
};

AppliedFilters.propTypes = {
  appliedFilters: activeFiltersShape.isRequired,
  hasPinnedToggle: PropTypes.bool.isRequired,
  isPinned: PropTypes.bool.isRequired,
  isSingleBranch: PropTypes.bool.isRequired,
  toggleIsPinned: PropTypes.func.isRequired,
  unapplyAllFilters: PropTypes.func.isRequired,
  unapplyFilter: PropTypes.func.isRequired
};

export default AppliedFilters;
